<ion-header>
  <ion-toolbar>
    <ion-title>Production Reason List</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <ion-row>
    <ion-col size="4" *ngFor="let reason of productionReasonList; let i = index">
      <button
        ion-button
        class="defect-item"
        (click)="selectReason(reason)"
        [ngClass]="{ 'defect-item--selected': reason.selected }"
      >
        <ion-text color="dark">ID : {{ reason.reason.reasonId }} </ion-text>/
        <ion-text color="dark">{{ reason.reason.reasonName }} </ion-text>
      </button>
    </ion-col>
  </ion-row>
</ion-content>
<ion-footer class="ion-padding ion-justify-content-end">
  <ion-button (click)="save()">Save</ion-button>
</ion-footer>
